'use client';

import { TestimonialCard } from './TestimonialCard';
import { useScrollAnimation, useStaggeredScrollAnimation } from '@/hooks/use-scroll-animation';

interface TestimonialsClientProps {
  testimonials: any[];
}

/**
 * Client-side Testimonials component
 * Handles scroll animations for testimonial cards
 */
export function TestimonialsClient({ testimonials }: TestimonialsClientProps) {
  const titleRef = useScrollAnimation<HTMLDivElement>('fade-in-down', {
    threshold: 0.2,
    delay: 0,
  });

  const { getItemProps } = useStaggeredScrollAnimation('fade-in-up', {
    threshold: 0.15,
    delay: 100,
  });

  return (
    <>
      <div
        ref={titleRef.ref as React.RefObject<HTMLDivElement>}
        style={titleRef.style}
        className="text-center mb-12"
      >
        <h2 className="text-3xl md:text-4xl font-bold">What Our Clients Say</h2>
        <p className="text-lg text-muted-foreground mt-2">We are trusted by our clients for our exceptional service</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {testimonials.map((testimonial, idx) => {
          const itemProps = getItemProps(idx);
          return (
            <div key={testimonial.id} {...itemProps}>
              <TestimonialCard testimonial={testimonial} />
            </div>
          );
        })}
      </div>
    </>
  );
}
